import 'bootstrap';

(function (Drupal, $, once) {

  'use strict';



	Drupal.behaviors.searchMenuToggle = {
		attach: function (context) {
      const showSearchForm = function() {
        document.querySelector('.navbar-utility .views-exposed-form').classList.toggle('open');
        document.querySelector('.utility-nav-search .form-control').focus();
      }
      let utilitySearchToggler = document.querySelector('.navbar-utility .search-toggler');
      if (utilitySearchToggler) {
        const $elements = $(once('searchToggle', '.navbar-utility .search-toggler'));
        if($elements.length) {
          $elements.on('click', showSearchForm);
        }
        
      }
      let utilitySearchClose = document.querySelector('.utility-nav-search .form-close-btn');
      if (utilitySearchClose) {
        const $elements2 = $(once('searchClose', '.utility-nav-search .form-close-btn'));
        if($elements2.length) {
          $elements2.on('click', showSearchForm);
        }
      }
		}
	};
  Drupal.behaviors.lundModal = {
    attach: function (context) {
      window.addEventListener('load', function() {
        if(document.querySelector('.modal')) {
          jQuery('#paywall-modal').modal('show');
        }
      });
    }
  };
  Drupal.behaviors.lundProgramModal = {
    attach: function (context) {
      let $programModalTriggers = $(once('programModal', '.program-modal-trigger'));
      if($programModalTriggers.length) {
        $programModalTriggers.each(function(index, trigger) {
          trigger.addEventListener('click', function(e) {
            e.preventDefault();
            let programName = e.target.dataset.programName;
            let programType = e.target.dataset.programType;
            let linkOneName = e.target.dataset.programLinkOneName;
            let linkOneUrl = e.target.dataset.programLinkOneUrl;
            let linkTwoName = e.target.dataset.programLinkTwoName;
            let linkTwoUrl = e.target.dataset.programLinkTwoUrl;
            let linkThreeName = e.target.dataset.programLinkThreeName;
            let linkThreeUrl = e.target.dataset.programLinkThreeUrl;
            // console.table({
            //   programName: programName,
            //   programType: programType,
            //   linkOneName: linkOneName,
            //   linkOneUrl: linkOneUrl,
            //   linkTwoName: linkTwoName,
            //   linkTwoUrl: linkTwoUrl,
            // })
            let modalProgramName = document.querySelector('#program-information-modal #program-name');
            let modalProgramType = document.querySelector('#program-information-modal #program-type');
            let modalLinkOne = document.querySelector('#program-information-modal #program-link-one');
            let modalLinkTwo = document.querySelector('#program-information-modal #program-link-two');
            let modalLinkThree = document.querySelector('#program-information-modal #program-link-three');
            
            if(programName != '') {
              modalProgramName.innerHTML = programName;
            }
            if(programType != '') {
              modalProgramType.innerHTML = programType;
            }
            if(linkOneName != '') {
              modalLinkOne.innerHTML = linkOneName;
              modalLinkOne.setAttribute('href', linkOneUrl);
            }
            if(linkTwoName != '') {
              modalLinkTwo.innerHTML = linkTwoName;
              modalLinkTwo.setAttribute('href', linkTwoUrl);
            }
            if(linkThreeName != '') {
              modalLinkThree.innerHTML = linkThreeName;
              modalLinkThree.setAttribute('href', linkThreeUrl);
            }
          });
        });
      }
    }
  };
})(Drupal, jQuery, once);
